import React, { useEffect, useId, useMemo, useState } from 'react'

import { useWindowResize } from '@utils/domUtils'

import styles from './HighlightMask.module.scss'

interface Props {
  rect: DOMRect | null
  radius?: number
  onScrimClick?: () => void
  grow?: { mobile?: number; desktop?: number }
  offsetX?: number
  offsetY?: number
}

export const HighlightMask: React.FC<Props> = ({
  rect,
  radius = 8,
  onScrimClick,

  grow,
  offsetX = 0,
  offsetY = 0,
}) => {
  const maskId = useId()
  const [vp, setVp] = useState({
    w: document.documentElement.clientWidth,
    h: document.documentElement.clientHeight,
  })
  const isMobile = useWindowResize()

  const growValue = (isMobile ? grow?.mobile : grow?.desktop) ?? 6

  useEffect(() => {
    const onResize = () =>
      setVp({
        w: document.documentElement.clientWidth,
        h: document.documentElement.clientHeight,
      })
    window.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
      window.removeEventListener('orientationchange', onResize)
    }
  }, [])

  const hole = useMemo(() => {
    if (!rect) return null
    const x = Math.max(0, rect.left + offsetX - growValue)
    const y = Math.max(0, rect.top + offsetY - growValue)
    const w = Math.max(0, rect.width + 2 * growValue)
    const h = Math.max(0, rect.height + 2 * growValue)
    return { x, y, w, h, r: Math.max(0, radius) }
  }, [rect, radius, grow, offsetX, offsetY])

  return (
    <div className={styles.maskWrapper} onClick={onScrimClick}>
      <svg width='100%' height='100%' viewBox={`0 0 ${vp.w} ${vp.h}`} preserveAspectRatio='none'>
        <defs>
          <mask id={maskId} maskUnits='userSpaceOnUse'>
            <rect x='0' y='0' width={vp.w} height={vp.h} fill='white' />
            {hole && (
              <rect
                x={hole.x}
                y={hole.y}
                width={hole.w}
                height={hole.h}
                rx={hole.r}
                ry={hole.r}
                fill='black'
              />
            )}
          </mask>
        </defs>
        <rect
          x='0'
          y='0'
          width={vp.w}
          height={vp.h}
          fill='var(--overlay-high-em)'
          mask={`url(#${maskId})`}
        />
      </svg>
    </div>
  )
}
